import { defineModule } from "@kubdee/sdk";
import { MODULES } from "@kubdee/shared";
import { migrations } from "./migrations";
import { fleetDoctypes } from "./doctypes";

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = "Van";
const MODULE_COLOR = "#2490EF";

export default defineModule({
  name: MODULES.FLEET,
  label: "จัดการยานพาหนะ",
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: "1.0.0",
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING],
  category: "logistics",
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: "จัดการยานพาหนะ",
    icon: MODULE_ICON,
    groups: [
      {
        label: "จัดการ",
        items: [
          { label: "แดชบอร์ด", icon: "LayoutDashboard", path: "/fleet" },
          { label: "ยานพาหนะ", icon: "CarFront", path: "/fleet/vehicles" },
          { label: "ยี่ห้อ/รุ่น", icon: "Tags", path: "/fleet/brands" },
          { label: "ลานจอดรถ", icon: "MapPin", path: "/fleet/vehicle-yards" },
          { label: "โอนย้ายรถ", icon: "ArrowRightLeft", path: "/fleet/vehicle-transfers" },
        ],
      },
      {
        label: "ซ่อมบำรุง",
        items: [
          { label: "บันทึกซ่อม", icon: "Wrench", path: "/fleet/maintenance" },
          { label: "กำหนดการ", icon: "CalendarClock", path: "/fleet/maintenance/schedule" },
        ],
      },
      {
        label: "ทะเบียน & ประกัน",
        items: [
          { label: "ต่อทะเบียน", icon: "FileText", path: "/fleet/registrations" },
          { label: "ประกันภัย", icon: "Shield", path: "/fleet/insurance" },
          { label: "ภาษีรถ", icon: "Receipt", path: "/fleet/tax" },
        ],
      },
      {
        label: "รายงาน",
        items: [
          { label: "ค่าซ่อมบำรุง", icon: "BarChart3", path: "/fleet/reports/maintenance-costs" },
          { label: "วงจรรถ", icon: "TrendingUp", path: "/fleet/reports/vehicle-lifecycle" },
        ],
      },
      {
        label: "ตั้งค่า",
        items: [
          { label: "ตั้งค่าทั่วไป", icon: "Settings", path: "/fleet/settings" },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "vehicles", label: "ยานพาหนะ" },
    { key: "vehicle-yards", label: "ลานจอดรถ", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "brands", label: "ยี่ห้อ" },
    { key: "maintenance", label: "ซ่อมบำรุง", type: "submittable" },
    { key: "insurance", label: "ประกันภัย" },
    { key: "registration", label: "ทะเบียน" },
  ],
  availableHooks: [
    { event: "fleet.vehicle.statusChanged", label: "เปลี่ยนสถานะรถ" },
    // #415 — Maintenance workflow transition hooks (wired via workflow module)
    { event: "fleet.maintenance.startService", label: "เริ่มซ่อมบำรุง" },
    { event: "fleet.maintenance.completeService", label: "เสร็จสิ้นซ่อมบำรุง" },
    { event: "fleet.maintenance.cancelService", label: "ยกเลิกซ่อมบำรุง" },
  ],

  fixtures: [
    { file: "roles.json", doctype: "role" },
    { file: "brands.json", doctype: "vehicle_brand" },
    { file: "body-types.json", doctype: "vehicle_body_type" },
    { file: "colors.json", doctype: "vehicle_color" },
    { file: "maintenance-types.json", doctype: "maintenance_type" },
  ],

  moduleMigrations: migrations,

  registeredDoctypes: fleetDoctypes,
});
